__turbopack_context__.v({
  "card": "AmityScholars-module-scss-module__6YHUnG__card",
  "cardContent": "AmityScholars-module-scss-module__6YHUnG__cardContent",
  "carouselWrapper": "AmityScholars-module-scss-module__6YHUnG__carouselWrapper",
  "nextArrow": "AmityScholars-module-scss-module__6YHUnG__nextArrow",
  "prevArrow": "AmityScholars-module-scss-module__6YHUnG__prevArrow",
  "profileImageWrapper": "AmityScholars-module-scss-module__6YHUnG__profileImageWrapper",
  "quoteIcon": "AmityScholars-module-scss-module__6YHUnG__quoteIcon",
  "scholarName": "AmityScholars-module-scss-module__6YHUnG__scholarName",
  "sectionWrapper": "AmityScholars-module-scss-module__6YHUnG__sectionWrapper",
  "testimonialText": "AmityScholars-module-scss-module__6YHUnG__testimonialText",
  "title": "AmityScholars-module-scss-module__6YHUnG__title",
});
